import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Divider,
  LinearProgress,
  Paper,
  Chip,
  TextField,
  Tooltip,
  Typography,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  DialogContentText,
  DialogActions,
  Autocomplete,
  Popover,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  Box,
} from "@mui/material";
import {
  Send as SendIcon,
  CheckCircle as CheckCircleIcon,
  RotateLeft as RotateLeftIcon,
  Drafts as DraftsIcon,
  FileCopyTwoTone as FileCopyTwoToneIcon,
  EditTwoTone as EditTwoToneIcon,
  AddCircleTwoTone as AddCircleTwoToneIcon,
  DeleteForeverOutlined as DeleteForeverOutlinedIcon,
  SaveAltOutlined as SaveAltOutlinedIcon,
  ViewList as ViewListIcon,
  Email as EmailIcon,
  SaveOutlined as SaveOutlinedIcon,
  ChevronRight as ChevronRightIcon,
  ChevronLeft as ChevronLeftIcon,
  Schedule as ScheduleIcon,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  getTemplateVariables,
  postBTemplate,
  postTempVar,
  sendFUMail,
  setEBDraft,
  updateTempVar,
  updateBTemplate,
  removeTempVar,
  deleteBTemplate,
  getBTemplates,
} from "../../../redux/modules/email";
import DialogTitle from "../../../components/DialogTitle";
import config from "../../../config";
import { updateLastActivity } from "../../../redux/modules/leads";
import { validateEmail } from "../../../utils/validators";
import {
  makeFirstLetterCaps,
  normalizeHtml,
  truncateString,
} from "../../../utils";
import ContentEditable from "react-contenteditable";
import { Link } from "react-router-dom";
import { getCurrentDatetime, getUTCDatetime } from "../../../utils/format_date";
import FollowUpEmailInput from "../../../containers/Leads/components/FollowUpEmailInput";
import {
  addTemplateToStage,
  deleteDealTemplate,
  getDealTemplates,
  postDealTemplate,
  updateDealTemplate,
} from "../../../redux/modules/deals";
import { setAlert } from "../../../redux/modules/alert";
import FileUploader from "../../../components/FileUploader/FileUploader";
import EmailTypeSelector from "./EmailTypeSelector";
const withoutWhiteSpaces = /\s/;

function TempVarItem({ varItem, load, setLoading, loading, setCopiedVar }) {
  const dispatch = useDispatch();
  const [edit, setEdit] = useState(false);
  const [varData, setVarData] = useState({
    var_id: varItem.tb_id,
    var_name: varItem.var_name || "",
    var_value: varItem.var_value || "",
  });
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setVarData({
      var_id: varItem.tb_id,
      var_name: varItem.var_name || "",
      var_value: varItem.var_value || "",
    });
  }, [varItem]);

  const scrollToRef = useRef();
  const copyRef = useRef();

  useEffect(() => {
    if (copyRef.current) {
      clearTimeout(copyRef.current);
    }

    if (copied) {
      copyRef.current = setTimeout(() => {
        clearTimeout(copyRef.current);
        setCopied(false);
      }, 3000);
    }

    return () => {
      clearTimeout(copyRef.current);
    };
  }, [copied]);

  const onEditClick = () => {
    setEdit(true);
    let scrollTimeout = setTimeout(() => {
      scrollToRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
      clearTimeout(scrollTimeout);
    }, 300);
  };

  const onCancel = () => {
    setEdit(false);
    setVarData({ ...varData, var_value: varItem.var_value || "" });
  };

  const onValueChange = (name) => (el) => {
    setVarData({ ...varData, [name]: el.target.value });
    let scrollTimeout = setTimeout(() => {
      scrollToRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
      clearTimeout(scrollTimeout);
    }, 300);
  };

  const onSaveUpdate = () => {
    setLoading(true);
    dispatch(updateTempVar(varData))
      .then(() => {
        setLoading(false);
        setEdit(false);
        load();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onDelete = () => {
    setLoading(true);
    dispatch(removeTempVar(varItem.tb_id))
      .then(() => {
        setLoading(false);
        setEdit(false);
        load();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onCopying = () => {
    navigator.clipboard.writeText(`{${varItem.var_name}}`);
    setCopiedVar(varItem.var_name);
    setCopied(true);
  };

  return (
    <div className="temp_var_container">
      <div className="temp_var_item">
        <div className="var_data">
          <Tooltip title={varItem.var_name}>
            <Typography>{`{${truncateString(
              varItem.var_name,
              20
            )}}`}</Typography>
          </Tooltip>
        </div>
        <div className="var_tools">
          <Tooltip title="Edit Variable">
            <IconButton
              style={{ padding: 0, marginRight: 6 }}
              onClick={onEditClick}
            >
              <EditTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={copied ? "Copied" : "Copy Variable"}>
            <IconButton
              className="copy_variable_btn"
              style={{ padding: 0 }}
              onClick={onCopying}
            >
              <FileCopyTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <Collapse in={edit}>
        <div className="variable_input_wrapper">
          {/* <TextField placeholder='Variable Name' value={varData.var_name} onChange={onValueChange('var_name')} helperText="Variable name should be without white spaces." /> */}
          <Divider />
          <TextField
            variant="standard"
            placeholder="Variable Value"
            value={varData.var_value}
            onChange={onValueChange("var_value")}
            maxRows={6}
            multiline
          />
          <div className="var_save_wrapper update">
            <div className="var_save_btns">
              <Button color="primary" onClick={onCancel}>
                cancel
              </Button>
              <Divider orientation="vertical" flexItem />
              <Button
                ref={scrollToRef}
                color="primary"
                onClick={onSaveUpdate}
                disabled={
                  loading ||
                  !varData.var_value ||
                  varItem.var_value === varData.var_value
                }
              >
                update
              </Button>
            </div>
            <IconButton style={{ padding: 0 }} onClick={onDelete}>
              <DeleteForeverOutlinedIcon color="error" fontSize="small" />
            </IconButton>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

function TempVars({ vars, load, setLoading, loading, setCopiedVar, rerender }) {
  const dispatch = useDispatch();
  const [add, setAdd] = useState(false);
  const [varData, setVarData] = useState({ var_name: "", var_value: "" });
  const [maxHeight, setMaxHeight] = useState(200);

  const onAddClick = () => {
    setMaxHeight(150);
    setAdd(true);
  };

  const onCancel = () => {
    setMaxHeight(200);
    setAdd(false);
    setVarData({ var_name: "", var_value: "" });
  };

  const onValueChange = (name) => (el) => {
    rerender();
    setVarData({ ...varData, [name]: el.target.value });
  };

  const onAddNewVar = () => {
    setLoading(true);
    dispatch(postTempVar(varData))
      .then(() => {
        setLoading(false);
        setMaxHeight(200);
        setAdd(false);
        setVarData({ var_name: "", var_value: "" });
        load();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div style={{ width: 250 }}>
      <Collapse in={!add}>
        <div
          style={{
            padding: 15,
            maxHeight,
            overflow: "auto",
            transition: "max-height 1s cubic-bezier(0.82, 0.93, 0.55, 0.95) 0s",
          }}
        >
          {vars.length ? (
            vars.map((tv, v) => (
              <TempVarItem
                key={v}
                varItem={tv}
                load={load}
                setLoading={setLoading}
                loading={loading}
                setCopiedVar={setCopiedVar}
              />
            ))
          ) : (
            <Typography variant="caption">No variables available...</Typography>
          )}
        </div>
        <Divider />
        <div style={{ textAlign: "center", paddingBottom: 15, paddingTop: 10 }}>
          <Tooltip title="Add a variable">
            <IconButton style={{ padding: 0 }} onClick={onAddClick}>
              <AddCircleTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </Collapse>
      <Collapse in={add}>
        <div className="variable_input_container">
          <div className="variable_input_wrapper">
            <TextField
              variant="standard"
              size="small"
              placeholder="Variable Name"
              value={varData.var_name}
              onChange={onValueChange("var_name")}
              helperText="Variable name should be without white spaces."
            />
            <TextField
              variant="standard"
              size="small"
              placeholder="Variable Value"
              value={varData.var_value}
              onChange={onValueChange("var_value")}
              maxRows={6}
              multiline
            />
            <div className="var_save_wrapper">
              <Button color="primary" onClick={onCancel}>
                cancel
              </Button>
              <Divider orientation="vertical" flexItem />
              <Button
                color="primary"
                onClick={onAddNewVar}
                disabled={
                  loading ||
                  !(
                    varData.var_name &&
                    varData.var_value &&
                    !withoutWhiteSpaces.test(varData.var_name)
                  )
                }
              >
                save
              </Button>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

const DealEmailTemplate = ({
  open,
  close,
  multiple,
  contact,
  lead,
  stage,
  loadingDU,
  bcc = false,
  setEmailConfigData,
  dealDetails,
  setAttachments,
  attachments,
}) => {
  const dispatch = useDispatch();

  const contactFields = useSelector((state) => state.forms.contactFields);
  const [emails, setEmails] = useState(
    contactFields.filter((field) => field.type === "email")
  );
  const [cEmails, setCEmails] = useState(lead?.emails || []);
  const followUpBody = useSelector((state) => state.email.followUpBody);
  const [email, setE] = useState({
    email_sub: "",
    email_body: "",
  });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const communicationEmail = useSelector(
    (state) => state.auth.communicationEmail
  );

  const bodyTemplates = useSelector((state) => state?.email?.bodyTemplates);
  const staffname = useSelector((state) => state.auth.staffname);
  const [selectedBTemp, setBSelectedTemp] = useState("");
  const [openSave, setOpenSave] = useState(false);
  const [tempName, setTempName] = useState("");
  const [saving, setSaving] = useState(false);
  const [scheduleTime, setScheduleTime] = useState("");
  const availableEmails = multiple
    ? [communicationEmail]
    : emails?.map((ems) => lead[ems?.label]).filter((v) => v);
  const disableTempSave =
    ![...availableEmails, ...cEmails].length ||
    !normalizeHtml(email.email_body || "").trim();
  const [confirmUpdate, setConfirm] = useState(false);
  const [confirmDelete, setConDel] = useState(false);
  const [moved, setMoved] = useState(0);
  const [templateChipMoved, setTemplateChipMoved] = useState(0);
  const [copiedVar, setCopiedVar] = useState(null);
  const [reload, setReload] = useState(0);
  const [opencc, setOpencc] = useState(false);
  const [openbcc, setOpenbcc] = useState(false);
  const [ccEmails, setccEmails] = useState([]);
  const [bccEmails, setbccEmails] = useState([]);
  const [toEmails, setToEmails] = useState([]);
  const [loadingVars, setLoadingVars] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [tempVars, setTempVars] = useState([]);
  const [render, rerender] = useState(false);
  // const [emailType, setEmailType] = useState(false);
  const copiedTimeout = useRef();
  const chipsRail = useRef();
  const templateChipsRail = useRef();
  const totalScroll = useRef(5);
  const templateChipsTotalScroll = useRef(5);
  const intialrender = useRef(true);

  const [addStage, setAddStage] = useState(false);
  const [emailType, setEmailType] = useState("branded");
  const [plainData, setPlainData] = useState({
    senderName: "",
    email: "",
    logo: null,
    logoPreview: null,
    fullName: "",
    designation: "",
    phone: "",
    email: "",
    address: "",
  });

  useEffect(() => {
    if (copiedTimeout.current) {
      clearTimeout(copiedTimeout.current);
    }

    copiedTimeout.current = copiedVar
      ? setTimeout(() => {
          setCopiedVar(null);
          clearTimeout(copiedTimeout.current);
        }, 20000)
      : null;

    return () => {
      if (copiedTimeout.current) {
        clearTimeout(copiedTimeout.current);
      }
    };
  }, [copiedVar]);

  useEffect(() => {
    if (open) {
      setEmails(contactFields.filter((field) => field.type === "email"));
      setCEmails(lead.emails || []);
    }
  }, [contactFields, open]);

  useEffect(() => {
    if (email.email_body != followUpBody) {
      setE({ ...email, email_body: followUpBody });
    }
  }, [followUpBody]);

  const onChangeContent = (name) => (e) => {
    setE({ ...email, [name]: e.target.value });
  };

  const onCloseDialog = () => {
    close();
    setSent(false);
    setE({ email_sub: "", email_body: "" });
    setBSelectedTemp("");
    setScheduleTime("");
    setMoved(0);
    setTemplateChipMoved(0);
    setOpencc(false);
    setOpenbcc(false);
    setEmailType("branded");
    totalScroll.current = 5;
    templateChipsTotalScroll.current = 5;
    intialrender.current = true;
  };

  const onBTempChange = (e) => {
    const eValue = e?.value || "";
    setBSelectedTemp(eValue);

    if (eValue !== "") {
      const selectedBodyTemplate = bodyTemplates.find(
        (bt) => bt.tb_id === eValue
      );

      setE({
        ...email,
        email_sub: selectedBodyTemplate["subject"],
        email_body: selectedBodyTemplate["body"],
      });

      if (selectedBodyTemplate?.is_plain_email === "1") {
        setEmailType("plain");
        setPlainData((prev) => ({
          ...prev,
          senderName: selectedBodyTemplate?.signature_sender_name || "",
          email: selectedBodyTemplate?.signature_email || "",
          fullName: selectedBodyTemplate?.signature_name || "",
          designation: selectedBodyTemplate?.signature_designation || "",
          phone: selectedBodyTemplate?.signature_phone || "",
          address: selectedBodyTemplate?.signature_address || "",
          logoPreview: selectedBodyTemplate?.signature_logo_path || "",
          ...(selectedBodyTemplate?.signature_logo_path && {
            logofromserver: true,
            logopathFromServer: selectedBodyTemplate?.signature_logo_path,
          }),
        }));
      } else {
        setEmailType("branded");
      }
    } else {
      setE({
        email_sub: "",
        email_body: followUpBody || "",
      });
      setEmailType("branded");
      setPlainData(null);
    }
  };

  const onSaveAndSend = () => {
    setTempName(email.email_sub);
    setOpenSave(true);
  };

  const onTempNameChange = (e) => {
    setTempName(e.target.value);
  };

  useEffect(() => {
    if (bodyTemplates?.length > 0 && intialrender?.current) {
    } else {
      if (intialrender.current) {
        setE({
          ...email,
          email_sub: "",
          email_body: "",
        });
        setBSelectedTemp("");
      }
    }
  }, [bodyTemplates, reload]);

  const onTempSave = (send) => () => {
    if (emailType === "plain") {
      if (!plainData?.fullName) {
        dispatch(
          setAlert(
            `Please fill the full name in email signature details before saving a plain email template.`,
            "info"
          )
        );
        return;
      }
      if (
        plainData?.logopathFromServer &&
        !plainData?.logo &&
        !plainData?.logoRemoved
      ) {
        dispatch(
          setAlert(
            "Please insert the logo once again to save the same.",
            "info"
          )
        );
        return;
      }
    }

    setSaving(true);

    const postData = {
      name: tempName,
      email_subject: email.email_sub,
      email_body: normalizeHtml(email.email_body),
      ...(emailType === "plain" && {
        is_plain_email: true,
        signature: {
          signature_name: plainData?.fullName || "",
          signature_designation: plainData?.designation || "",
          signature_email: plainData?.email || "",
          signature_phone: plainData?.phone || "",
          signature_address: plainData?.address || "",
          signature_sender_name: plainData?.senderName || "",
        },
      }),
    };

    const formData = new FormData();
    formData.append("data", JSON.stringify(postData));
    formData.append("company_logo", plainData?.logo);

    dispatch(postBTemplate(formData))
      .then((res) => {
        const { template_id } = res;
        setBSelectedTemp(template_id);
        setOpenSave(false);
        setSaving(false);
        dispatch(setAlert(`Email template created successfully`, "success"));
        dispatch(getBTemplates());
        setAddStage(true);
        setReload(reload + 1);
        intialrender.current = false;
        setE({
          ...email,
          email_sub: email.email_sub,
          email_body: email.email_body,
        });
      })
      .catch((error) => {
        setSaving(false);
        dispatch(
          setAlert(
            error?.response?.data?.message || `Failed to insert`,
            "error"
          )
        );
      });
  };

  const onVariableClick = (variable) => () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(variable);
    }
  };

  const onTemplateUpdate = () => {
    setConfirm(true);
  };

  const onUpdateConfirm = () => {
    if (emailType === "plain") {
      if (!plainData?.fullName) {
        dispatch(
          setAlert(
            `Please fill the full name in email signature details before updetails a plain email template.`,
            "info"
          )
        );
        return;
      }
    }

    setSaving(true);

    const updateData = {
      template_id: selectedBTemp,
      email_subject: email.email_sub,
      email_body: normalizeHtml(email.email_body),
      ...(emailType === "plain" && {
        is_plain_email: true,
        signature: {
          signature_name: plainData?.fullName || "",
          signature_designation: plainData?.designation || "",
          signature_email: plainData?.email || "",
          signature_phone: plainData?.phone || "",
          signature_address: plainData?.address || "",
          signature_sender_name: plainData?.senderName || "",
          ...(plainData?.logoRemoved &&
            plainData?.logofromserver && {
              signature_logo_path: plainData?.logopathFromServer,
            }),
        },
      }),
    };
    const formData = new FormData();
    formData.append("data", JSON.stringify(updateData));

    if (plainData?.logo instanceof File || plainData?.logo?.type) {
      formData.append("company_logo", plainData?.logo);
    }

    dispatch(updateBTemplate(formData))
      .then(() => {
        setConfirm(false);
        setSaving(false);
        setReload(reload + 1);
        intialrender.current = false;
      })
      .catch((error) => {
        setSaving(false);
        dispatch(
          setAlert(
            error?.response?.data?.message || `Failed to update`,
            "error"
          )
        );
      });
  };

  const onTemplateDelete = () => {
    setConDel(true);
  };

  const onDeleteConfirm = () => {
    setSaving(true);
    dispatch(deleteBTemplate(selectedBTemp))
      .then(() => {
        setBSelectedTemp("");
        setE({ ...email, email_sub: "", email_body: followUpBody });
        setConDel(false);
        setSaving(false);
      })
      .catch(() => {
        setSaving(false);
      });
  };

  const scrollChips = (direction, chipRef) => () => {
    const currentRef = chipRef === "template" ? templateChipsRail : chipsRail;
    const count = Math.ceil(currentRef.current.scrollWidth / 180 - 1);
    if (chipRef !== "template") {
      totalScroll.current = count;
    } else {
      templateChipsTotalScroll.current = count;
    }

    if (direction === "left") {
      currentRef.current.scrollLeft -= 180;
      if (chipRef === "template" && templateChipMoved !== 0) {
        setTemplateChipMoved(templateChipMoved - 1);
      } else if (moved !== 0) {
        setMoved(moved - 1);
      }
    } else if (direction === "right") {
      currentRef.current.scrollLeft += 180;
      if (chipRef === "template" && templateChipMoved !== count) {
        setTemplateChipMoved(templateChipMoved + 1);
      } else if (moved !== count) {
        setMoved(moved + 1);
      }
    }
  };

  const maxId = bodyTemplates?.reduce(
    (max, item) => (item.id > max ? item.id : max),
    0
  );

  const onAddtemplateToStage = () => {
    const postData = {
      ccEmails: ccEmails,
      bccEmails: bccEmails,
      toEmails: toEmails,
      template: selectedBTemp,
      email_subject: email.email_sub,
      email_body: normalizeHtml(email.email_body),
    };
    setEmailConfigData(postData);
    onCloseDialog();
  };
  const handleEmailTypeChange = (event) => {
    setEmailType(event.target.checked);
  };

  useEffect(() => {
    const recipients =
      dealDetails?.to_address?.length > 0
        ? dealDetails.to_address
        : (dealDetails?.tagged_contacts ?? [])
            .flatMap((item) => item?.emails ?? [])
            .filter((email) => email);
    setToEmails(recipients);
    setccEmails(dealDetails?.cc_address || []);
    setbccEmails(dealDetails?.bcc_address || []);
    if (dealDetails?.cc_address?.length > 0) {
      setOpencc(true);
    }
    if (dealDetails?.bcc_address?.length > 0) {
      setOpenbcc(true);
    }
  }, [dealDetails]);
  const multipleEmails = useSelector((state) => state.leads.emails);

  const handleDelete = (i) => () => {
    setEmails(emails.filter((f, j) => j != i));
  };

  const handleCEDelete = (i) => () => {
    setCEmails(cEmails.filter((f, j) => j != i));
  };

  const emailsAvailable = availableEmails.length || cEmails.length;

  const allEmails = contactFields
    ?.filter((field) => field?.type === "email")
    ?.map((ems) => lead[ems?.label])
    ?.filter((v) => v);

  const handleVClick = (event) => {
    if (!tempVars.length) {
      setLoadingVars(true);
      dispatch(getTemplateVariables())
        .then((res) => {
          if (res.result) {
            setTempVars(res.result);
          }

          setLoadingVars(false);
        })
        .catch(() => {
          setLoadingVars(false);
        });
    }
    setAnchorEl(event.currentTarget);
  };

  const loadTempVariables = () => {
    setLoadingVars(true);
    dispatch(getTemplateVariables())
      .then((res) => {
        if (res.result) {
          setTempVars(res.result);
        }

        setLoadingVars(false);
      })
      .catch(() => {
        setLoadingVars(false);
      });
  };

  const handleVClose = () => {
    setAnchorEl(null);
  };

  const rrFU = () => {
    rerender(!render);
  };

  return (
    <Dialog
      open={open}
      onClose={onCloseDialog}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { overflowY: "hidden" },
      }}
    >
      {loadingDU ? (
        <DialogContent>
          <LinearProgress style={{ margin: 3 }} />
        </DialogContent>
      ) : (
        <>
          <DialogTitle onClose={onCloseDialog}>
            <div className="fu-email-title">
              <EmailIcon color="primary" />
              <Typography variant="h6" className="fu-email-t-text">
                {bcc ? "Email Send Configure" : "Email Template"}
              </Typography>
            </div>
          </DialogTitle>
          <Divider />
          <DialogContent style={{ paddingBottom: 16 }}>
            <Collapse in={!sent}>
              {bcc && (
                <>
                  <div className="fu-email-to">
                    <Typography variant="h6" style={{ fontSize: 16 }}>
                      To
                    </Typography>

                    <div className="fu-email-cc-wrapper">
                      {opencc ? null : (
                        <Typography
                          variant="h6"
                          style={{ marginRight: 5, fontSize: 16 }}
                          onClick={() => setOpencc(true)}
                        >
                          Cc
                        </Typography>
                      )}
                      {openbcc ? null : (
                        <Typography
                          variant="h6"
                          style={{ fontSize: 16 }}
                          onClick={() => setOpenbcc(true)}
                        >
                          Bcc
                        </Typography>
                      )}
                    </div>
                  </div>
                  <FollowUpEmailInput
                    lead={lead}
                    allEmails={allEmails}
                    emailField={toEmails}
                    setEmailField={setToEmails}
                    validateEmail={validateEmail}
                  />

                  <Collapse sx={{ mt: 1 }} in={opencc}>
                    <Typography variant="h6" style={{ fontSize: 16 }}>
                      Cc
                    </Typography>
                    <FollowUpEmailInput
                      lead={lead}
                      allEmails={allEmails}
                      emailField={ccEmails}
                      setEmailField={setccEmails}
                      validateEmail={validateEmail}
                    />
                  </Collapse>

                  <Collapse sx={{ mt: 1 }} in={openbcc}>
                    <div className="bcc-container">
                      <Typography variant="h6" style={{ fontSize: 16 }}>
                        Bcc
                      </Typography>

                      <FollowUpEmailInput
                        lead={lead}
                        allEmails={allEmails}
                        emailField={bccEmails}
                        setEmailField={setbccEmails}
                        validateEmail={validateEmail}
                      />
                    </div>
                  </Collapse>
                </>
              )}

              <div className="fu-email-sub-wrap">
                <Typography
                  variant="h6"
                  style={{ fontSize: 16, paddingTop: 12 }}
                >
                  Subject
                </Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  className="fu-email-sub"
                  margin="dense"
                  onChange={onChangeContent("email_sub")}
                  value={email.email_sub}
                />
              </div>
              <Autocomplete
                size="small"
                sx={{ marginTop: "20px" }}
                autoHighlight={true}
                options={
                  bodyTemplates?.length > 0
                    ? bodyTemplates.map((bodyTemplate) => ({
                        label: bodyTemplate?.name || "",
                        value: bodyTemplate?.tb_id || "",
                        is_plain: bodyTemplate?.is_plain_email,
                      }))
                    : [{ label: "", value: "" }]
                }
                value={
                  bodyTemplates
                    ?.map((bt) => ({
                      label: bt?.name || "",
                      value: bt?.tb_id || "",
                      is_plain: bt?.is_plain_email,
                    }))
                    ?.find((opt) => opt?.value === String(selectedBTemp)) ||
                  null
                }
                noOptionsText="No templates available"
                getOptionLabel={(options) => options?.label || ""}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                    }}
                  >
                    <span style={{ fontSize: 14 }}>{option.label}</span>
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: option.is_plain === "1" ? "#2e7d32" : "#1565c0",
                        backgroundColor:
                          option.is_plain === "1" ? "#E8F5E9" : "#E3F2FD",
                        borderRadius: 10,
                        padding: "2px 8px",
                      }}
                    >
                      {option.is_plain === "1" ? "Plain" : "Branded"}
                    </span>
                  </li>
                )}
                onChange={(e, bodyTemplate) => onBTempChange(bodyTemplate)}
                style={{ minWidth: 220 }}
                renderInput={(templateLists) => {
                  const selectedOption = bodyTemplates
                    ?.map((bt) => ({
                      label: bt?.name || "",
                      value: bt?.tb_id || "",
                      is_plain: bt?.is_plain_email,
                    }))
                    ?.find((opt) => opt?.value === String(selectedBTemp));

                  return (
                    <TextField
                      {...templateLists}
                      label="Select Email Template"
                      variant="outlined"
                      InputLabelProps={{
                        style: {
                          color: "#263238",
                        },
                      }}
                      InputProps={{
                        ...templateLists.InputProps,
                        endAdornment: (
                          <>
                            {selectedOption && (
                              <span
                                style={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  color:
                                    selectedOption.is_plain === "1"
                                      ? "#2e7d32"
                                      : "#1565c0",
                                  backgroundColor:
                                    selectedOption.is_plain === "1"
                                      ? "#E8F5E9"
                                      : "#E3F2FD",
                                  borderRadius: 10,
                                  padding: "2px 8px",
                                  marginRight: 8,
                                }}
                              >
                                {selectedOption.is_plain === "1"
                                  ? "Plain"
                                  : "Branded"}
                              </span>
                            )}
                            {templateLists.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  );
                }}
              />

              <EmailTypeSelector
                emailType={emailType}
                setEmailType={setEmailType}
                plainData={plainData}
                setPlainData={setPlainData}
              />

              <div className="e_body_bar" style={{ margin: "10px 0" }}>
                <Typography variant="h6" style={{ fontSize: 16 }}>
                  Body
                </Typography>
                <div className="temp_var_holder">
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={scrollChips("left")}
                    disabled={moved === 0}
                  >
                    <ChevronLeftIcon fontSize="medium" />
                  </IconButton>
                  <div className="chips-container">
                    <div className="chips-rail" ref={chipsRail}>
                      {config.dealtemplateVariables.map((tv, t) => (
                        <Tooltip key={t} title="click to copy">
                          <Chip
                            className="var_chip"
                            size="small"
                            label={tv}
                            onClick={onVariableClick(tv)}
                          />
                        </Tooltip>
                      ))}
                      {contactFields.map((cf, t) => (
                        <Tooltip key={t} title="click to copy">
                          <Chip
                            className="var_chip"
                            size="small"
                            label={`{field-${cf.field_name}}`}
                            onClick={onVariableClick(
                              `{field-${cf.field_name}}`
                            )}
                          />
                        </Tooltip>
                      ))}
                    </div>
                  </div>
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={scrollChips("right")}
                    disabled={moved === totalScroll.current}
                  >
                    <ChevronRightIcon fontSize="medium" />
                  </IconButton>
                  {copiedVar ? (
                    <Tooltip title="Copied variable">
                      <Chip
                        className="var_chip"
                        size="small"
                        label={truncateString(copiedVar, 20)}
                        variant="outlined"
                        color="primary"
                      />
                    </Tooltip>
                  ) : null}
                  <Tooltip title="Custom variables">
                    <IconButton style={{ padding: 0 }} onClick={handleVClick}>
                      <ViewListIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Popover
                    open={!!anchorEl}
                    anchorEl={anchorEl}
                    onClose={handleVClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <Typography
                      style={{ padding: "8px 15px", fontWeight: "bold" }}
                    >
                      Email variables
                    </Typography>
                    <Divider />
                    <div>{loadingVars ? <LinearProgress /> : null}</div>
                    <TempVars
                      vars={tempVars}
                      load={loadTempVariables}
                      setLoading={setLoadingVars}
                      loading={loadingVars}
                      setCopiedVar={setCopiedVar}
                      rerender={rrFU}
                    />
                  </Popover>
                </div>
              </div>
              <div className="fu-eml-body">
                <Paper className="fu-eml-bd-paper">
                  <ContentEditable
                    className="fu-email-ta"
                    onChange={onChangeContent("email_body")}
                    html={email.email_body}
                  />
                </Paper>
                {loading ? <LinearProgress /> : null}
              </div>

              <div className="mail-actions">
                {bcc && (
                  <div style={{ display: "flex", gap: 8 }}>
                    <Tooltip
                      title={
                        "Select an email template, then click to add it to the deal configuration."
                      }
                      arrow
                      placement="bottom"
                    >
                      <span>
                        <Button
                          className="split-button-menu"
                          disabled={!selectedBTemp}
                          onClick={onAddtemplateToStage}
                        >
                          <SaveOutlinedIcon
                            fontSize="small"
                            color={!selectedBTemp ? "disabled" : "primary"}
                            sx={{ mr: 0.5 }}
                          />
                          <span>Add this to configure</span>
                        </Button>
                      </span>
                    </Tooltip>
                  </div>
                )}

                <div className="template-actions">
                  <Typography style={{ padding: "5px 10px" }}>
                    Template
                  </Typography>
                  <Divider orientation="vertical" flexItem />
                  {selectedBTemp && !staffname ? (
                    <Button
                      className="split-button-menu"
                      onClick={onTemplateUpdate}
                      disabled={disableTempSave}
                    >
                      <SaveAltOutlinedIcon
                        fontSize="small"
                        color={disableTempSave ? "disabled" : "primary"}
                      />
                      <span>Update</span>
                    </Button>
                  ) : null}
                  {selectedBTemp && !staffname ? (
                    <Divider orientation="vertical" flexItem />
                  ) : null}

                  <Button
                    className="split-button-menu"
                    onClick={onSaveAndSend}
                    disabled={disableTempSave}
                  >
                    <SaveOutlinedIcon
                      fontSize="small"
                      color={disableTempSave ? "disabled" : "primary"}
                    />
                    <span>Save</span>
                  </Button>
                  {selectedBTemp && !staffname ? (
                    <Divider orientation="vertical" flexItem />
                  ) : null}
                  {selectedBTemp && !staffname ? (
                    <Button
                      className="split-button-menu"
                      onClick={onTemplateDelete}
                      disabled={disableTempSave}
                    >
                      <DeleteForeverOutlinedIcon
                        fontSize="small"
                        color={disableTempSave ? "disabled" : "error"}
                      />
                      <span>Delete</span>
                    </Button>
                  ) : null}
                </div>
              </div>
            </Collapse>
            <Dialog open={openSave} onClose={() => setOpenSave(false)}>
              <DialogTitle onClose={() => setOpenSave(false)}>
                Save Template
              </DialogTitle>
              <Divider />
              <DialogContent>
                <TextField
                  size="small"
                  margin="dense"
                  variant="outlined"
                  placeholder="Template Name"
                  value={tempName}
                  onChange={onTempNameChange}
                />
                {saving ? <LinearProgress /> : null}
                <div className="temp-save-btn-grp">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onTempSave()}
                    disabled={!tempName}
                  >
                    Save
                  </Button>
                </div>
              </DialogContent>
            </Dialog>
            <Collapse in={sent}>
              <div className="action-success">
                <CheckCircleIcon className="success-color" fontSize="large" />
                <Typography className="success-container marginT15">
                  {scheduleTime
                    ? "Email scheduled successfully"
                    : "Email sent successfully"}
                </Typography>
                {scheduleTime ? (
                  <Link className="click_link" to="/email">
                    See all schedules
                  </Link>
                ) : null}
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: 15 }}
                  onClick={onCloseDialog}
                >
                  CLOSE
                </Button>
              </div>
            </Collapse>
          </DialogContent>
          <Dialog
            open={confirmUpdate || confirmDelete}
            onClose={() => setConfirm(false)}
            maxWidth="xs"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {confirmDelete
                  ? `Do you want to delete the current template?`
                  : ""}
                {confirmUpdate
                  ? `Do you want to update the current template?`
                  : ""}
              </DialogContentText>
              {confirmDelete ? (
                <Typography className="warning-container">
                  After deleting the template, you cannot recover it. Please
                  click on confirm, if you are sure to delete the template.
                  Otherwise you can cancel it.
                </Typography>
              ) : null}
              {confirmUpdate ? (
                <Typography className="warning-container">
                  Updating the template will override the existing. You can even
                  save the template in different name and use it.
                </Typography>
              ) : null}
            </DialogContent>
            {saving ? <LinearProgress /> : null}
            <DialogActions>
              <Button
                onClick={() =>
                  confirmDelete ? setConDel(false) : setConfirm(false)
                }
                color="primary"
              >
                Cancel
              </Button>
              <Button
                style={{ color: "red" }}
                onClick={confirmDelete ? onDeleteConfirm : onUpdateConfirm}
                autoFocus
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Dialog>
  );
};

export default DealEmailTemplate;
